import React, { useState, useEffect } from 'react';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';
import { useNavigate, useLocation } from 'react-router-dom';

const AppointmentLinks = () => {
  const [linkText, setLinkText] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [existingLink, setExistingLink] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  // Get appointment id from query params
  const searchParams = new URLSearchParams(location.search);
  const appointmentId = searchParams.get('id');

  // Fetch existing appointment_links text
  useEffect(() => {
    if (!appointmentId) return;
  fetch(`${process.env.REACT_APP_VENDOR_DOMAIN}/api/appointments-link?id=${appointmentId}`)
      .then(res => res.json())
      .then(data => {
        if (data && data.link) {
          setExistingLink(data.link);
          setLinkText(data.link); // Optionally prefill editor
        }
      });
  }, [appointmentId]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');
    try {
      const res = await fetch(`${process.env.REACT_APP_VENDOR_DOMAIN}/api/appointments-link`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: appointmentId, link: linkText }),
      });
      const data = await res.json();
      if (res.ok && data.success) {
        setMessage('Link submitted successfully!');
        setExistingLink(linkText);
       
      } else {
        setMessage(data.message || 'Submission failed.');
      }
    } catch {
      setMessage('Submission failed.');
    }
    setLoading(false);
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>Appointment Information</h2>
      {/* Show existing appointment_links text if present */}
      {existingLink && (
        <div style={styles.existingLinkBox}>
          <div style={styles.label}>Current Link/Notes:</div>
          <div
            style={styles.linkContent}
            dangerouslySetInnerHTML={{ __html: existingLink }}
          />
        </div>
      )}
      <form onSubmit={handleSubmit} style={styles.form}>
        <label style={styles.label}>Zoom/Meeting Link or Notes:</label>
        <h6>Provide the link or any relevant notes for the appointment. You can use zoom or any other video conferencing tool.</h6>
        <ReactQuill
          theme="snow"
          value={linkText}
          onChange={setLinkText}
          style={{ ...styles.richTextBox, minHeight: '240px', height: '240px' }}
          placeholder="Paste your meeting link or add notes here..."
        />
        <div style={{ height: '32px' }} /> {/* Spacer to move button lower */}
        <button
          type="submit"
          style={styles.button}
          disabled={loading || !linkText.trim()}
        >
          {loading ? 'Submitting...' : 'Submit'}
        </button>
        {message && <div style={styles.message}>{message}</div>}
      </form>
      <button
        style={styles.backBtn}
        onClick={() => navigate('/vendorappointments')}
      >
        ← Back to Appointments
      </button>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: '600px',
    margin: '40px auto',
    padding: '32px',
    background: '#fff',
    borderRadius: '14px',
    boxShadow: '0 4px 24px rgba(141,110,54,0.10)',
    fontFamily: 'Segoe UI, Arial, sans-serif',
  },
  title: {
    marginBottom: '28px',
    color: '#4078c0',
    fontSize: '1.7rem',
    textAlign: 'center',
    fontWeight: 'bold',
    letterSpacing: '1px',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  label: {
    fontWeight: 'bold',
    color: '#8d6e36',
    fontSize: '1.08rem',
    marginBottom: '6px',
  },
  richTextBox: {
    minHeight: '240px',
    height: '240px',
    marginBottom: '8px',
  },
  button: {
    background: '#388e3c',
    color: '#fff',
    fontWeight: 'bold',
    border: 'none',
    borderRadius: '8px',
    padding: '10px 22px',
    fontSize: '1rem',
    cursor: 'pointer',
    boxShadow: '0 1px 4px #c8e6c9',
    transition: 'background 0.2s',
    marginTop: '8px',
  },
  backBtn: {
    background: '#4078c0',
    color: '#fff',
    fontWeight: 'bold',
    border: 'none',
    borderRadius: '8px',
    padding: '8px 22px',
    fontSize: '1rem',
    cursor: 'pointer',
    boxShadow: '0 1px 4px #e0cfa0',
    transition: 'background 0.2s',
    textDecoration: 'none',
    marginTop: '24px',
    display: 'block',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  message: {
    textAlign: 'center',
    color: '#388e3c',
    fontWeight: 'bold',
    marginTop: '8px',
  },
  existingLinkBox: {
    background: '#f5f6fa',
    borderRadius: '8px',
    padding: '14px',
    marginBottom: '18px',
    border: '1px solid #e0cfa0',
  },
  linkContent: {
    fontSize: '1.05rem',
    color: '#4078c0',
    marginTop: '6px',
    wordBreak: 'break-word',
  },
};

export default AppointmentLinks;